import React from 'react';
import { Loading } from 'components/Loading';

import { Flexer } from '@ontruck/orc';

const LoadingCentered = () => (
  <Flexer.Parent alignItems="center" justifyContent="center" pBottom="L">
    <Flexer.Child pBottom="L">
      <Loading />
    </Flexer.Child>
  </Flexer.Parent>
);

export default LoadingCentered;
